export const FLAG_GETTING_CABIN_CREW_DOCUMENT_TYPES =
  'FLAG_GETTING_CABIN_CREW_DOCUMENT_TYPES';
export const GET_CABIN_CREW_DOCUMENT_TYPES = 'GET_CABIN_CREW_DOCUMENT_TYPES';
export const CLEAR_CABIN_CREW_DOCUMENT_TYPES =
  'CLEAR_CABIN_CREW_DOCUMENT_TYPES';
